// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"500":"f3c6577c","507":"852132ea","751":"852132ea"}[chunkId] + ".chunk.css";
};